import React, { useEffect, useRef, useState } from "react";
import parse from "html-react-parser";
import PropTypes from "prop-types"; // Importar PropTypes
import Cookies from "js-cookie";
import esTexts from "../../texts/es.json";
import enTexts from "../../texts/en.json";
import "./DetailPrint.scss";
import { getGImage } from "../../helpers";
import { GatsbyImage } from "gatsby-plugin-image";

function DetailPrint({ showModal, closeModalProp, title, image, data }) {
  const [openModal, setOpenModal] = useState(showModal);
  const modalRef = useRef(null);

  const language = Cookies.get("dpalanguage") || "es";
  const texts = language === "es" ? esTexts : enTexts;

  /*   componentDidMount() {
    window.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      openModal: nextProps.showModal,
    });
  }

  handleClickOutside = (event) => {
    if (this.modal) {
      if (!this.modal.contains(event.target) && this.modal) {
        this.openModal(false);
      }
    }
  }; */

  const handleClickOutside = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      setOpenModal(false);
      closeModalProp();
    }
  };

  useEffect(() => {
    setOpenModal(showModal);
  }, [showModal]);

  useEffect(() => {
    window.addEventListener("mousedown", handleClickOutside);
    // return () => window.removeEventListener('mousedown', handleClickOutside);
  }, []);
  return (
    openModal && (
      <div className="c-detail-print-modal" ref={modalRef}>
        <div className="row-flex">
          <div className="c-detail-print-modal__image">
            <GatsbyImage image={getGImage(image)} alt={title} />
            <div className="data">
              {data && (
                <>
                  <p>
                    <b>{texts.detailPrint.author}: </b>
                    {data.meta4DPAPRINTS1Autor}
                  </p>
                  <p>
                    <b>{texts.detailPrint.editor}: </b>
                    {data.meta4DPAPRINTS10Editor}
                  </p>
                  <p>
                    <b>{texts.detailPrint.collection}: </b>
                    {data.meta4DPAPRINTS2Coleccion}
                  </p>
                  <p>
                    <b>{texts.detailPrint.graphicDesign}: </b>
                    {data.meta4DPAPRINTS3DisenoGrafico}
                  </p>
                  <p>
                    <b>{texts.detailPrint.dimensions}: </b>
                    {data.meta4DPAPRINTS4Dimensiones}
                  </p>
                  <p>
                    <b>{texts.detailPrint.pages}: </b>
                    {data.meta4DPAPRINTS5nPaginas}
                  </p>
                  <p>
                    <b>{texts.detailPrint.publisher}: </b>
                    {data.meta4DPAPRINTS6Editorial}
                  </p>
                  <p>
                    <b>{texts.detailPrint.isbn}: </b>
                    {data.meta4DPAPRINTS7ISBN}
                  </p>
                  <p>
                    <b>{texts.detailPrint.language}: </b>
                    {data.meta4DPAPRINTS9Idioma}
                  </p>
                  <p>
                    <b>{texts.detailPrint.publicationDate}: </b>
                    {data.meta4DPAPRINTS8Fecha}
                  </p>
                </>
              )}
            </div>
          </div>
          <div className="c-detail-print-modal__container">
            <div className="c-detail-print-modal__description">
              <h2>{title}</h2>
              <h3>{data.meta4DPAPRINTS8Fecha}</h3>
              <p>{data && parse(data.content)}</p>
            </div>
          </div>
        </div>
        <div>
          <a
            className="see-buy-button"
            target="_blank"
            rel="noopener noreferrer"
            href={data?.meta4DPAPRINTSLINK}
          >
            {texts.detailPrint.seeBuy}
          </a>
        </div>
      </div>
    )
  );
}

DetailPrint.propTypes = {
  showModal: PropTypes.bool.isRequired,
  closeModalProp: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
};

export default DetailPrint;
